"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
var styles = __importStar(require("./DatePicker.module.css"));
var DatePicker = (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.pdf = false;
        _this.pdf = document.body.classList.contains("pdf");
        return _this;
    }
    DatePicker.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, id = _a.id, onChange = _a.onChange, _b = _a.errors, errors = _b === void 0 ? {} : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
        var value = json_data[id] || "";
        var error = errors[id];
        var classRoot = styles.root + " " + (error && styles.rootError);
        if (this.pdf) {
            value = moment_1.default(json_data[id]).format("MM/DD/YYYY");
        }
        return (React.createElement("div", null,
            React.createElement("input", { className: classRoot, id: id, value: value, onChange: function (event) {
                    onChange(id, event.target.value);
                }, type: "date", disabled: disabled, max: "2999-12-31" }),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    return DatePicker;
}(React.Component));
exports.DatePicker = DatePicker;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGF0ZVBpY2tlci5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2NvbXBvbmVudHMvRGF0ZVBpY2tlci9EYXRlUGlja2VyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBRzlCLGtEQUEyQjtBQUMzQiw4REFBaUQ7QUFVakQ7SUFBZ0MsOEJBQW9DO0lBR2hFLG9CQUFZLEtBQUs7UUFBakIsWUFDSSxrQkFBTSxLQUFLLENBQUMsU0FHZjtRQU5PLFNBQUcsR0FBRyxLQUFLLENBQUE7UUFLZixLQUFJLENBQUMsR0FBRyxHQUFHLFFBQVEsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQTs7SUFDdEQsQ0FBQztJQUNNLDJCQUFNLEdBQWI7UUFDVSxJQUFBLGVBQXFFLEVBQXBFLHdCQUFTLEVBQUUsVUFBRSxFQUFFLHNCQUFRLEVBQUUsY0FBVyxFQUFYLGdDQUFXLEVBQUUsZ0JBQWdCLEVBQWhCLHFDQUE4QixDQUFBO1FBQzNFLElBQUksS0FBSyxHQUFHLFNBQVMsQ0FBQyxFQUFFLENBQUMsSUFBSSxFQUFFLENBQUE7UUFDL0IsSUFBTSxLQUFLLEdBQUcsTUFBTSxDQUFDLEVBQUUsQ0FBQyxDQUFBO1FBQ3hCLElBQU0sU0FBUyxHQUFNLE1BQU0sQ0FBQyxJQUFJLFVBQUksS0FBSyxJQUFJLE1BQU0sQ0FBQyxTQUFTLENBQUUsQ0FBQTtRQUUvRCxJQUFJLElBQUksQ0FBQyxHQUFHLEVBQUU7WUFDVixLQUFLLEdBQUcsZ0JBQU0sQ0FBQyxTQUFTLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsWUFBWSxDQUFDLENBQUE7U0FDckQ7UUFFRCxPQUFPLENBQ0g7WUFDSSwrQkFDSSxTQUFTLEVBQUUsU0FBUyxFQUNwQixFQUFFLEVBQUUsRUFBRSxFQUNOLEtBQUssRUFBRSxLQUFLLEVBQ1osUUFBUSxFQUFFLFVBQUMsS0FBSztvQkFDWixRQUFRLENBQUMsRUFBRSxFQUFFLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUE7Z0JBQ3BDLENBQUMsRUFDRCxJQUFJLEVBQUMsTUFBTSxFQUNYLFFBQVEsRUFBRSxRQUFRLEVBQ2xCLEdBQUcsRUFBQyxZQUFZLEdBQ2xCO1lBQ0QsS0FBSyxJQUFJLDJCQUFHLFNBQVMsRUFBRSxNQUFNLENBQUMsS0FBSztnQkFBRyxLQUFLO29CQUFNLENBQ2hELENBQ1QsQ0FBQTtJQUNMLENBQUM7SUFDTCxpQkFBQztBQUFELENBQUMsQUFuQ0QsQ0FBZ0MsS0FBSyxDQUFDLFNBQVMsR0FtQzlDO0FBbkNZLGdDQUFVIn0=